import { number, object, string } from 'yup';

const maxYear = new Date().getFullYear() + 1;

export type VehicleForm = {
    brand: string;
    model: string;
    color: string;
    plate: string;
    manufactureYear: string;
};

export const vehicleFormSchema = object().shape({
    brand: string()
        .min(3, 'Marca debe tener al menos 3 caracteres')
        .required('Marca es requerida'),
    model: string()
        .min(3, 'Modelo debe tener al menos 3 caracteres')
        .required('Modelo es requerido'),
    color: string()
        .min(3, 'Color debe tener al menos 3 caracteres')
        .required('Color es requerido'),
    plate: string()
        .min(6, 'Placa debe tener al menos 6 caracteres')
        .required('Placa es requerida'),
    manufactureYear: number()
        .transform((value) => {
            if (value === '' || value == null) return undefined;
            return Number(value);
        })
        .integer('Año de fabricación debe ser un número entero')
        .min(2002, 'Año de fabricación debe ser 2002 o posterior')
        .max(maxYear, `Año de fabricación no puede ser mayor a ${maxYear}`)
        .required('Año de fabricación es requerido'),
});
